<template>
  <section class="index-news-container" v-if="indexNews">
    <section class="index-news-list-container">
      <div class="liveMiddle">
        <!-- <span class="iconfont">&#xe617;</span> -->
        <a :href="$i18n.path('news')" target="_blank">{{ $t('index-news.title') }}</a>
        <div class="flex-grow"></div>
        <a class="more iconfont" :href="$i18n.path('news')">{{ $t('index-news.more') }} ></a>
      </div>
      <ul class="index-news-list" :key="index" v-for="(item,index) in indexNews.slice(0,3)">
        <li class="index-news-list-time">
          <a :href="$i18n.path(`news/${item.id}`)" target="_blank" class="index-news-list-title">
            <h2>{{item.title}}</h2>
          </a>
          <section class="end-line">
            <span :class="[item.typeClass,'type-all']">{{item.typeName}}</span>
            <span class="news-time">{{item.createDate | formatTime}}</span>
            <table style="clear:both"></table>
          </section>
        </li>
      </ul>
    </section>
  </section>
</template>
<script>
export default {
  name: "index-news",
  props: ["indexNews"],
  data() {
    return {};
  },
  methods: {}
};
</script>
<style lang="less" scoped>
.index-news-container {
  margin-top: 20px;
  background-color: #fff;
  padding: 22px 20px 10px 20px;

  .liveMiddle {
    margin-bottom: 12px;
    padding-bottom: 16px;
    clear: both;
    font-weight: bolder;
    background-color: #fff;
    display: flex;
    align-items: center;
    border-bottom: 1px solid rgba(241, 243, 247, 1);
    .iconfont {
      color: #478cf3;
      font-size: 25px;
      font-weight: 100;
    }
    a {
      line-height: 24px;
      color: #000;
      font-size: 16px;
    }

    .flex-grow {
      flex-grow: 1;
    }

    a.more {
      font-size: 12px;
      font-weight: 400;
      color: #999999;
    }
  }

  .index-news-list {
    margin-bottom: 10px;
    padding-bottom: 10px;
    border-bottom: 1px dashed rgb(218, 218, 218);

    &:last-child {
      border-bottom: none;
      padding-bottom: 0;
      margin-bottom: 0;
    }
  }

  .index-news-list-time {
    font-size: 12px;
    // padding: 5px 0;

    .index-news-list-title {
      h2 {
        font-size: 14px;
        color: #222222;
        line-height: 1.5;
        padding: 5px 0;

        &:hover {
          color: #559be3;
        }
      }
    }

    .end-line {
      margin: 8px 0 10px 0;

      .news-time {
        float: right;
        color: #999;
      }

      .type-all {
        /* text-align: left; */
        border-radius: 3px;
        font-weight: 400;
        color: rgba(50, 120, 210, 1);
      }
    }
  }
}
</style>
